import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import ImagePopover from "editor/components/ImagePopover";
import styles from "./ImageDisplay.css";

export default class ImageDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      imageElement: null,
    };
    this.activate = this._activate.bind(this);
    this.deactivate = this._deactivate.bind(this);
  }

  _activate() {
    this.setState({ isActive: true });
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur(); // Remove focus from the editor.
    }
  }

  _deactivate() {
    this.setState({ isActive: false });
  }

  render() {
    return (
      <div
        className={classNames(styles.root, {
          [styles.isActive]: this.state.isActive,
        })}
        ref={element => {
          if (!this.state.imageElement) {
            this.setState({ imageElement: element });
          }
        }}
        onClick={this.activate}
      >
        <ImagePopover
          closeModal={this.deactivate}
          imageElement={this.state.imageElement}
          blockKey={this.props.blockKey}
          isActive={this.state.isActive}
        />
        <img
          contentEditable={false}
          src={this.props.imgSrc}
          alt={this.props.alt_text}
        />
      </div>
    );
  }
}

ImageDisplay.propTypes = {
  blockKey: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  alt_text: PropTypes.string,
};
